import { Theme } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { ModalProvider } from "./hooks/UseModal/modalProvider";
import { FirstVisitModalContainer } from "./containers/FirstVisitModalContainer";

type AppProps = {
  theme: Theme;
};

export const App = ({ theme }: AppProps): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ModalProvider>
        <FirstVisitModalContainer />
      </ModalProvider>
    </ThemeProvider>
  );
};

export default App;
